import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { IntegrationSmsToScreenData } from './Data';

interface ScreenItemState {
  id: number;
  name: string;
  smsKeyword: string;
  smsTo: string;
  demoUrl: string;
  liveUrl: string;
}

export interface IntegrationSmsToScreenState extends BaseIntegrationState {
  eventReloadQueue?: string;
  eventReload?: string;
  channel?: string;
  queue?: string;
  queueProcessingDelay?: number;
  screens: ScreenItemState[];
}

export class IntegrationSmsToScreenModel extends BaseIntegration<
  IntegrationSmsToScreenData,
  IntegrationSmsToScreenState
> {
  parse(data: IntegrationSmsToScreenData) {
    super.parse(data);

    this.state.eventReloadQueue = data.settings?.sms_to_screen?.event_reload_queue;
    this.state.eventReload = data.settings?.sms_to_screen?.event_reload;
    this.state.channel = data.settings?.sms_to_screen?.channel;
    this.state.queue = data.settings?.sms_to_screen?.queue;
    this.state.queueProcessingDelay = data.settings?.sms_to_screen?.queue_processing_delay;

    if (data.settings?.sms_to_screen?.screens) {
      this.state.screens = data.settings.sms_to_screen.screens.map<ScreenItemState>((screen) => {
        return {
          id: screen.id,
          name: screen.name,
          smsKeyword: screen.sms_keyword,
          smsTo: screen.sms_to,
          demoUrl: screen.demo_url,
          liveUrl: screen.live_url
        };
      });
    } else {
      this.state.screens = [];
    }
  }

  hasVueComponent() {
    return false;
  }

  authorSignature(): string {
    return 'Ani Mikova';
  }
}
